module.exports = __webpack_public_path__ + "img/faculty.c230641e.svg";